import { Injectable } from '@angular/core';
import { UnsubscribableWithWorkerBlocForService } from '@bcf-v2-platforms/platform-worker/browser';
import { DeviceInfo } from '@bcf-v2-utilities/device-info/device-info';
import { ModalCookiesConsentChannels } from '@bcf-vanilla-ts-v1-logic-worker-modals/bloc/modal-cookies-consent/modal-cookies-consent-channels';
import { filter, first, map } from 'rxjs';
import { TwaNativeApiClient } from './twa-native-api-client';

enum AppTrackingTransparencyStatus {
  authorized = 'authorized',
  denied = 'denied',
  notDetermined = 'notDetermined',
  restricted = 'restricted'
}

@Injectable({
  providedIn: 'root'
})
export class TwaAppTrackingTransparency extends UnsubscribableWithWorkerBlocForService<ModalCookiesConsentChannels> {
  private _messageAction: string = 'app-tracking-transparency-get-status';

  constructor(
    private _twaNativeApiClient: TwaNativeApiClient,
    private _deviceInfo: DeviceInfo
  ) {
    super();
    this._initWorkerBloc('modal-cookies-consent');
  }

  public async initialize(): Promise<void> {
    const emitAnalyticsAcepted = (): void => {
      this._workerSubject('doAcceptCookiesConsent$').next(['Necessary', 'Analytics']);
    };
    if (await this._deviceInfo.getIsAndroid()) {
      emitAnalyticsAcepted();
      return;
    }
    this._twaNativeApiClient
      .getMessage()
      .pipe(
        filter((message: Record<string, any>) => message.action === this._messageAction),
        map((message: Record<string, any>) => message.status),
        first()
      )
      .subscribe((status: string) => {
        if (status === AppTrackingTransparencyStatus.denied || status === AppTrackingTransparencyStatus.restricted) {
          this._workerSubject('doAcceptCookiesConsent$').next(['Necessary']);
        } else {
          emitAnalyticsAcepted();
        }
      });
  }

  public askForAStatusUpdate(): void {
    this._twaNativeApiClient.sendMessage({ action: this._messageAction });
  }
}
